import { Alert, Box, Button, Card, CardActions, CardContent, Chip, Divider, Grid, LinearProgress, List, ListItem, ListItemIcon, ListItemText, Modal, Paper, Step, StepLabel, Stepper, Typography } from "@mui/material";
import { useState } from "react";
import * as React from "react";
import { Plan } from "../Plan/ChoosePlan";
import { AutoGraph, Bolt, Chat, CheckCircle, CheckCircleOutline, CreditCard, Email, Groups, Info, Security, Star, Storage, Workspaces } from "@mui/icons-material";
import stripeConfig from "../../services/config_stripe.json";
import { KeyDriveBodyMax } from "../../components/KeydriveComponents/Fonts/Body/KeyDriveBodyMax";
import { KeyDrivePrimaryButton } from "../../components/KeydriveComponents/Buttons/KeyDrivePrimaryButton";
import { KeyDriveBodyMin } from "../../components/KeydriveComponents/Fonts/Body/KeyDriveBodyMin";
import { AddressElement, CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import { useNavigate, useParams } from "react-router-dom";
import { CreateSubscription } from "../../services/PaymentService";
import { KeyDriveDialog } from "../../components/KeydriveComponents/Dialog/KeyDriveDialog";
import { useProfile } from "../../context/ProfileProvider/useProfile";
import { KeydrivePlan } from "../../model/UserModel";
import { waurlBuilderComercial } from "../MyDataPage/components/utils/waSupportBuilder";

type LoadingStep = 'validating' | 'creating-payment' | 'processing' | 'finalizing' | 'complete' | null;

export default function Plans() {

    const stripe = useStripe();
    const [pricingModal, setPricingModal] = useState<boolean>(false);
    const [loadingModal, setLoadingModal] = useState<boolean>(false);
    const [successModal, setSuccessModal] = useState<boolean>(false);
    const [loadingStep, setLoadingStep] = useState<LoadingStep>(null);
    const [selectedPlan, setSelectedPlan] = useState<Plan | null>(null);
    const elements = useElements();
    const { email, nameOrg } = useParams();
    const navigate = useNavigate();
    const profile = useProfile();
    const [errorModal, setErrorModal] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);

    console.log(profile.login)

    function handleSelectPlan(plan: Plan) {
        setSelectedPlan(plan);
        setPricingModal(true);
    }
    

    const getLoadingSteps = () => {
        return [
            'Validando dados',
            'Criando método de pagamento',
            'Processando assinatura',
            'Finalizando',
        ];
    };

    const getCurrentStepIndex = () => {
        switch (loadingStep) {
            case 'validating': return 0;
            case 'creating-payment': return 1;
            case 'processing': return 2;
            case 'finalizing': return 3;
            case 'complete': return 4;
            default: return 0;
        }
    };
    
    async function handleSubscription() {
        setLoadingModal(true);
        
        try {
            setLoadingStep('validating');
            await new Promise(resolve => setTimeout(resolve, 800));

            const cardElement = elements?.getElement(CardElement);
            const addressElement = elements?.getElement(AddressElement);
            const addressElValue = await addressElement?.getValue();

            if (!addressElValue?.complete) {
                setLoadingModal(false);
                setLoadingStep(null);
                setErrorModal(true);
                return;
            }

            setLoadingStep('creating-payment');
            await new Promise(resolve => setTimeout(resolve, 1000));

            const stripePmRequest = await stripe?.createPaymentMethod({
                card: cardElement!,
                type: "card",
                billing_details: {
                    email: profile.login,
                    address: {
                        city: addressElValue?.value.address.city,
                        country: addressElValue?.value.address.country,
                        line1: addressElValue?.value.address.line1,
                        line2: addressElValue?.value.address.line2,
                        postal_code: addressElValue?.value.address.postal_code,
                        state: addressElValue?.value.address.state
                    },
                    name: addressElValue?.value.name,
                    phone: addressElValue?.value.phone!
                }
            });

            if (stripePmRequest?.error != undefined) {
                setLoadingModal(false);
                setLoadingStep(null);
                setErrorModal(true);
                return;
            }

            setLoadingStep('processing');
            await new Promise(resolve => setTimeout(resolve, 1000));

            await CreateSubscription({
                paymentMethodId: stripePmRequest?.paymentMethod?.id!,
                email: profile.login!,
                priceId: selectedPlan?.priceId!,
                Address: {
                    city: addressElValue?.value.address.city!,
                    country: addressElValue?.value.address.country!,
                    line1: addressElValue?.value.address.line1!,
                    line2: addressElValue?.value.address.line2!,
                    postalCode: addressElValue?.value.address.postal_code!,
                    state: addressElValue?.value.address.state!,
                    phone: addressElValue?.value.phone!
                },
                clientName: addressElValue?.value.name!,
                createdByOnboard: false,
                internalName: nameOrg!
            });

            setLoadingStep('finalizing');
            await new Promise(resolve => setTimeout(resolve, 800));

            setLoadingStep('complete');
            await new Promise(resolve => setTimeout(resolve, 1000));

            setLoadingModal(false);
            setLoadingStep(null);
            setSuccessModal(true);
            setPricingModal(false);
            
        } catch (error: any) {
            setLoadingModal(false);
            setLoadingStep(null);
            setErrorModal(true);
            setErrorMessage(error.response.data);
        }
    }

    const plans: Plan[] = [
            {
                name: 'Essencial',
                priceId: stripeConfig.price_essential,
                features: [
                    { icon: <Groups fontSize="small" />, text: 'Até 5 usuários' },
                    { icon: <Storage fontSize="small" />, text: '100 GB de armazenamento' },
                    { icon: <Workspaces fontSize="small" />, text: '1 workspace' },
                    { icon: <Security fontSize="small" />, text: 'Permissões por grupo' },
                    { icon: <AutoGraph fontSize="small" />, text: 'Controle de versões' },
                    { icon: <Email fontSize="small" />, text: 'Suporte via e-mail' },
                ]
            },
            {
                name: 'Professional',
                priceId: stripeConfig.price_professional,            
                highlighted: true,
                badge: 'Mais Popular',
                features: [
                    { icon: <Groups fontSize="small" />, text: 'Até 15 usuários' },
                    { icon: <Storage fontSize="small" />, text: '1 TB de armazenamento' },
                    { icon: <Workspaces fontSize="small" />, text: 'Até 5 workspaces' },
                    { icon: <Bolt fontSize="small" />, text: 'Regras de workflow e temporalidade' },
                    { icon: <Security fontSize="small" />, text: 'APIs externas e auditoria' },
                    { icon: <Chat fontSize="small" />, text: 'Suporte via chat' },
                ]
            },
            {
                name: 'Scale',
                priceId: stripeConfig.price_scale,
                features: [
                    { icon: <Groups fontSize="small" />, text: 'Até 50 usuários' },
                    { icon: <Storage fontSize="small" />, text: '5 TB de armazenamento' },
                    { icon: <Workspaces fontSize="small" />, text: 'Workspaces ilimitados' },
                    { icon: <Security fontSize="small" />, text: 'Visualizador CAD' },
                    { icon: <Storage fontSize="small" />, text: 'Cold Storage inteligente' },
                    { icon: <AutoGraph fontSize="small" />, text: 'Relatórios avançados' },
                    { icon: <Star fontSize="small" />, text: 'Suporte dedicado' },
                ]
            }
    ];

    return (
        <Box>
            
        <Grid container spacing={3} justifyContent="center" sx={{ maxWidth: 1200, mx: 'auto', mt: 6 }}>
                {plans.map((plan, index) => (
                    <Grid item xs={12} md={4} key={index}>
                        <Card 
                            elevation={plan.highlighted ? 8 : 2}
                            sx={{ 
                                height: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                position: 'relative',
                                border: plan.highlighted ? '2px solid #22638D' : '1px solid #e0e0e0',
                                transform: plan.highlighted ? 'scale(1.02)' : 'scale(1)',
                                transition: 'all 0.3s ease',
                                background: plan.highlighted 
                                    ? 'linear-gradient(135deg, #ffffff 0%, #f5f9fc 100%)'
                                    : '#ffffff',
                                '&:hover': {
                                    transform: 'translateY(-4px)',
                                    boxShadow: plan.highlighted ? 12 : 6,
                                }
                            }}
                        >
                            {plan.badge && (
                                <Chip 
                                    label={plan.badge}
                                    color="primary"
                                    size="small"
                                    sx={{ 
                                        position: 'absolute',
                                        top: 12,
                                        right: 12,
                                        bgcolor: '#22638D',
                                        fontWeight: 600,
                                        height: 24,
                                        fontSize: '0.75rem'
                                    }}
                                />
                            )}
                            
                            <CardContent sx={{ flexGrow: 1, p: 2.5, pb: 1 }}>
                                {/* Plan Name */}
                                <Typography
                                    sx={{
                                        fontSize: '1.25rem',
                                        fontWeight: 700,
                                        color: plan.highlighted ? '#22638D' : '#0a1929',
                                        mb: 1.5
                                    }}
                                >
                                    {plan.name}
                                </Typography>
                                
                                {/* Price */}
                                {/* <Box sx={{ mb: 2 }}>
                                    <Box component="span" sx={{ 
                                        fontSize: '2rem', 
                                        fontWeight: 700,
                                        color: '#0a1929'
                                    }}>
                                        {plan.price}
                                    </Box>
                                    <Box component="span" sx={{ 
                                        fontSize: '0.95rem', 
                                        color: '#546e7a',
                                        ml: 0.5
                                    }}>
                                        {plan.period}
                                    </Box>
                                </Box> */}

                                <Divider sx={{ my: 2 }} />

                                {/* Features */}
                                <List sx={{ p: 0 }}>
                                    {plan.features.map((feature, idx) => (
                                        <ListItem key={idx} sx={{ px: 0, py: 0.5, minHeight: 32 }}>
                                            <ListItemIcon sx={{ minWidth: 28, color: '#22638D' }}>
                                                {feature.icon}
                                            </ListItemIcon>
                                            <ListItemText 
                                                primary={feature.text}
                                                primaryTypographyProps={{
                                                    fontSize: '0.875rem',
                                                    color: '#37474f',
                                                    lineHeight: 1.4
                                                }}
                                            />
                                        </ListItem>
                                    ))}
                                </List>
                            </CardContent>

                            <CardActions sx={{ p: 2.5, pt: 1 }}>
                                <Button
                                    fullWidth
                                    variant="contained"
                                    onClick={() => {
                                        //handleSelectPlan(plan)
                                        window.open(waurlBuilderComercial(), '_blank')
                                    }}
                                    sx={{
                                        py: 1,
                                        bgcolor: plan.highlighted ? '#22638D' : '#546e7a',
                                        fontWeight: 600,
                                        fontSize: '0.875rem',
                                        textTransform: 'none',
                                        '&:hover': {
                                            bgcolor: plan.highlighted ? '#1a4f6d' : '#37474f',
                                        }
                                    }}
                                >
                                    Contratar
                                </Button>
                            </CardActions>
                        </Card>
                    </Grid>
                ))}
            { profile?.signtureInformation?.currentPlan == KeydrivePlan.PERSONAL && (
                <Alert sx={{ marginTop: 4, backgroundColor: "#22638D", }} severity="info" icon={<Info sx={{ color: "white" }} />}>
                    <Typography color="white">
                        Você está utilizando um plano personalizado. Para contratar um plano, entre em contato com o suporte.
                    </Typography>
                </Alert>
            ) }
        </Grid>

            {/* Payment Modal */}
            { pricingModal && (
                <KeyDriveDialog
                    hidden={
                        loadingModal || successModal || errorModal
                    }
                    keyDriveDialogButtons={{
                        leftButtonMethod: () => { setPricingModal(false) },
                        rightButtonMethod: () => {
                            handleSubscription();
                        },
                        rightButtonText: "Confirmar Assinatura",
                        leftButtonText: "Cancelar"
                    }}
                    keyDriveDialogContent={{
                        dialogContent: (
                            <Box sx={{ mt: 3 }}>
                                {/* Selected Plan Info */}
                                {selectedPlan && (
                                    <Paper 
                                        elevation={0} 
                                        sx={{ 
                                            p: 3, 
                                            mb: 4, 
                                            bgcolor: '#f5f9fc',
                                            border: '2px solid #22638D',
                                            borderRadius: 2
                                        }}
                                    >
                                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                            <Box>
                                                <KeyDriveBodyMax 
                                                    color='#0a1929'
                                                    needBold={true}
                                                    needEllipses={false}
                                                    text={`Plano ${selectedPlan.name}`}
                                                />
                                            </Box>
                                            <Box sx={{ textAlign: 'right' }}>
                                                <Box component="span" sx={{ fontSize: '1.8rem', fontWeight: 700, color: '#22638D' }}>
                                                    {selectedPlan.price}
                                                </Box>
                                                <Box component="span" sx={{ fontSize: '1rem', color: '#546e7a', ml: 0.5 }}>
                                                    {selectedPlan.period}
                                                </Box>
                                            </Box>
                                        </Box>
                                    </Paper>
                                )}

                                {/* Card Element */}
                                <Box sx={{ mb: 3 }}>
                                    <KeyDriveBodyMin 
                                        color='#0a1929'
                                        needBold={true}
                                        needEllipses={false}
                                        text='Dados do Cartão'
                                    />
                                    <Paper 
                                        elevation={0} 
                                        sx={{ 
                                            p: 2.5, 
                                            mt: 1.5,
                                            border: '1px solid #e0e0e0',
                                            borderRadius: 2,
                                            '&:focus-within': {
                                                borderColor: '#22638D',
                                                boxShadow: '0 0 0 2px rgba(34, 99, 141, 0.1)'
                                            }
                                        }}
                                    >
                                        <CardElement 
                                            options={{
                                                style: {
                                                    base: {
                                                        fontSize: "16px",
                                                        color: "#0a1929",
                                                        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                                                        "::placeholder": {
                                                            color: "#9e9e9e",
                                                        },
                                                    },
                                                    invalid: {
                                                        color: "#d32f2f",
                                                    },
                                                },
                                                hidePostalCode: true,
                                            }}
                                        />
                                    </Paper>
                                </Box>

                                {/* Address Element */}
                                <Box>
                                    <KeyDriveBodyMin 
                                        color='#0a1929'
                                        needBold={true}
                                        needEllipses={false}
                                        text='Endereço de Cobrança'
                                    />
                                    <Paper 
                                        elevation={0} 
                                        sx={{ 
                                            p: 2.5, 
                                            mt: 1.5,
                                            border: '1px solid #e0e0e0',
                                            borderRadius: 2,
                                            '& .StripeElement': {
                                                padding: 0,
                                            }
                                        }}
                                    >
                                        <AddressElement 
                                            options={{
                                                allowedCountries: ["BR", "US"],
                                                mode: "billing",
                                                fields: {
                                                    phone: "always",
                                                },
                                                display: {
                                                    name: "full",
                                                },
                                                autocomplete: {
                                                    mode: "disabled",
                                                },
                                                defaultValues: {
                                                    address: {
                                                        country: "",
                                                        city: "",
                                                        line1: "",
                                                        line2: "",
                                                        postal_code: "",
                                                        state: ""
                                                    },
                                                    firstName: "",
                                                    lastName: "",
                                                    name: "",
                                                    phone: ""
                                                },
                                                validation: {
                                                    phone: {
                                                        required: "never"
                                                    }
                                                }
                                            }}
                                        />
                                    </Paper>
                                </Box>
                            </Box>
                        ),
                        dialogIcon: <CreditCard sx={{ color: "#22638D", width: "48px", height: "48px" }}/>,
                        dialogTitle: "Complete sua assinatura",
                        handleTogglDialog: () => {},
                        openDialog: pricingModal
                    }}
                />
            ) }

            <KeyDriveDialog 
                keyDriveDialogButtons={{
                    leftButtonMethod: () => {},
                    rightButtonMethod: () => {},
                    rightButtonText: undefined,
                    leftButtonText: undefined
                }}
                keyDriveDialogContent={{
                    dialogContent: (
                        <Box sx={{ 
                            textAlign: 'center',
                            py: 2
                        }}>
                            <KeyDriveBodyMax 
                                color='#0a1929'
                                needBold={true}
                                needEllipses={false}
                                text='Processando sua assinatura'
                            />
                            <Box sx={{ mt: 4, mb: 2, px: 2 }}>
                                <Stepper activeStep={getCurrentStepIndex()} alternativeLabel>
                                    {getLoadingSteps().map((label) => (
                                        <Step key={label}>
                                            <StepLabel>{label}</StepLabel>
                                        </Step>
                                    ))}
                                </Stepper>
                            </Box>
                            <LinearProgress 
                                sx={{ 
                                    mt: 3,
                                    height: 8,
                                    borderRadius: 4,
                                    bgcolor: '#e0e0e0',
                                    '& .MuiLinearProgress-bar': {
                                        bgcolor: '#22638D'
                                    }
                                }} 
                            />
                        </Box>
                    ),
                    handleTogglDialog: () => {},
                    openDialog: loadingModal
                }}
            />

            {/* Success Modal */}
            <KeyDriveDialog 
                keyDriveDialogButtons={{
                    leftButtonMethod: () => {},
                    rightButtonMethod: () => {
                        setSuccessModal(false);
                        navigate("/");
                    },
                    rightButtonText: "Começar a usar",
                    leftButtonText: undefined
                }}
                keyDriveDialogContent={{
                    dialogContent: (
                        <Box sx={{ 
                            textAlign: 'center',
                            py: 2
                        }}>
                            <Box sx={{
                                width: 80,
                                height: 80,
                                borderRadius: '50%',
                                bgcolor: '#e8f5e9',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                margin: '0 auto 24px'
                            }}>
                                <CheckCircle sx={{ color: "#4caf50", width: "56px", height: "56px" }} />
                            </Box>
                            
                            <KeyDriveBodyMax 
                                color='#0a1929'
                                needBold={true}
                                needEllipses={false}
                                text='Assinatura concluída!'
                            />
                            
                            <Box sx={{ mt: 2, mb: 3 }}>
                                <KeyDriveBodyMin 
                                    color='#546e7a'
                                    needBold={false}
                                    needEllipses={false}
                                    text='Parabéns! Sua assinatura foi processada com sucesso.'
                                />
                            </Box>

                            {selectedPlan && (
                                <Paper 
                                    elevation={0} 
                                    sx={{ 
                                        p: 3, 
                                        mt: 3,
                                        bgcolor: '#f5f9fc',
                                        border: '1px solid #22638D',
                                        borderRadius: 2,
                                        textAlign: 'left'
                                    }}
                                >
                                    <Box sx={{ mb: 2 }}>
                                        <KeyDriveBodyMin 
                                            color='#546e7a'
                                            needBold={true}
                                            needEllipses={false}
                                            text='Detalhes da assinatura:'
                                        />
                                    </Box>
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                                        <KeyDriveBodyMin 
                                            color='#0a1929'
                                            needBold={false}
                                            needEllipses={false}
                                            text='Plano:'
                                        />
                                        <KeyDriveBodyMin 
                                            color='#0a1929'
                                            needBold={true}
                                            needEllipses={false}
                                            text={selectedPlan.name}
                                        />
                                    </Box>
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                                        <KeyDriveBodyMin 
                                            color='#0a1929'
                                            needBold={false}
                                            needEllipses={false}
                                            text='Valor:'
                                        />
                                        <KeyDriveBodyMin 
                                            color='#22638D'
                                            needBold={true}
                                            needEllipses={false}
                                            text={`${selectedPlan.price}${selectedPlan.period}`}
                                        />
                                    </Box>
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <KeyDriveBodyMin 
                                            color='#0a1929'
                                            needBold={false}
                                            needEllipses={false}
                                            text='Email:'
                                        />
                                        <KeyDriveBodyMin 
                                            color='#0a1929'
                                            needBold={false}
                                            needEllipses={false}
                                            text={profile?.login!}
                                        />
                                    </Box>
                                </Paper>
                            )}

                            <Box sx={{ mt: 3 }}>
                                <KeyDriveBodyMin 
                                    color='#78909c'
                                    needBold={false}
                                    needEllipses={false}
                                    text='Saia e entre novamente na aplicação para atualizarmos sua assinatura!'
                                />
                            </Box>
                        </Box>
                    ),
                    handleTogglDialog: () => {},
                    openDialog: successModal
                }}
            />

            <KeyDriveDialog 
                keyDriveDialogButtons={{
                    leftButtonMethod: () => {},
                    rightButtonMethod: () => {
                        setErrorModal(false);
                        setPricingModal(true);
                    },
                    rightButtonText: "Tentar novamente",
                    leftButtonText: undefined
                }}
                keyDriveDialogContent={{
                    dialogContent: (
                        <Box sx={{ 
                            textAlign: 'center',
                            py: 2
                        }}>
                            <Box sx={{
                                width: 80,
                                height: 80,
                                borderRadius: '50%',
                                bgcolor: '#ffebee',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                margin: '0 auto 24px'
                            }}>
                                <Box sx={{
                                    width: 56,
                                    height: 56,
                                    borderRadius: '50%',
                                    border: '4px solid #d32f2f',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    position: 'relative'
                                }}>
                                    <Box sx={{
                                        width: 4,
                                        height: 24,
                                        bgcolor: '#d32f2f',
                                        borderRadius: 1,
                                        transform: 'rotate(45deg)',
                                        position: 'absolute'
                                    }} />
                                    <Box sx={{
                                        width: 4,
                                        height: 24,
                                        bgcolor: '#d32f2f',
                                        borderRadius: 1,
                                        transform: 'rotate(-45deg)',
                                        position: 'absolute'
                                    }} />
                                </Box>
                            </Box>
                            
                            <KeyDriveBodyMax 
                                color='#0a1929'
                                needBold={true}
                                needEllipses={false}
                                text='Erro ao processar assinatura'
                            />

                            { errorMessage != undefined && (
                                <KeyDriveBodyMin 
                                    color='#0a1929'
                                    needBold={true}
                                    needEllipses={false}
                                    text={errorMessage}
                                    sxStyles={{
                                        mt: 2,
                                    }}
                                />
                            ) }

                            <Paper 
                                elevation={0} 
                                sx={{ 
                                    p: 3, 
                                    mt: 3,
                                    bgcolor: '#fff3e0',
                                    border: '1px solid #ff9800',
                                    borderRadius: 2,
                                    textAlign: 'left'
                                }}
                            >
                                <KeyDriveBodyMin 
                                    color='#e65100'
                                    needBold={true}
                                    needEllipses={false}
                                    text='O que fazer agora?'
                                />
                                <Box sx={{ mt: 0.5 }}>
                                    <KeyDriveBodyMin 
                                        color='#5d4037'
                                        needBold={false}
                                        needEllipses={false}
                                        text='• Se você já possuir uma assinatura não poderá assinar novamente. Se precisar de um upgrade, contate nosso suporte.'
                                    />
                                </Box>
                                <Box sx={{ mt: 1.5 }}>
                                    <KeyDriveBodyMin 
                                        color='#5d4037'
                                        needBold={false}
                                        needEllipses={false}
                                        text='• Verifique os dados do cartão e tente novamente'
                                    />
                                </Box>
                                <Box sx={{ mt: 0.5 }}>
                                    <KeyDriveBodyMin 
                                        color='#5d4037'
                                        needBold={false}
                                        needEllipses={false}
                                        text='• Certifique-se de que todos os campos estão preenchidos corretamente'
                                    />
                                </Box>
                                <Box sx={{ mt: 0.5 }}>
                                    <KeyDriveBodyMin 
                                        color='#5d4037'
                                        needBold={false}
                                        needEllipses={false}
                                        text='• Se o problema persistir, entre em contato com o suporte'
                                    />
                                </Box>
                            </Paper>
                        </Box>
                    ),
                    handleTogglDialog: () => {},
                    openDialog: errorModal
                }}
            />
        </Box>
    );
}